module.exports = __webpack_public_path__ + "img/cs-logo-login.532f9d2a.svg";